import styled, { css } from 'styled-components';

import BaseButton from 'Elements/Button';
import { Cross } from '@solent-university/solent-icons';

export const Button = styled(BaseButton)`
    ${({ theme }) => css`
        position: absolute;
        right: 100%;
        top: calc(50% - 8rem);
        transform-origin: right center;
        transform: rotate(-90deg) translateY(-50%);
        border-radius: 0.5rem 0.5rem 0 0;
        padding: 0.75rem 3rem 0.75rem 1rem;

        @media ${theme.breakpoints.medium.media} {
            padding: 1rem 4.5rem 1rem 1.5rem;
        }
    `}
`;

export const Count = styled.span`
    ${({ theme }) => css`
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font-weight: 300;
        padding-bottom: 2rem;
        position: absolute;
        transform: rotate(90deg) translateX(-50%);
        top: 55%;
        width: 1rem;
        height: 1rem;
        box-sizing: content-box;
        right: 0.75rem;
        border: 0.125rem solid ${theme.colors.interactiveContrast.hex};
        line-height: 1;
        padding: 0.25rem;
        border-radius: 50%;

        @media ${theme.breakpoints.medium.media} {
            width: 2rem;
            height: 2rem;
            right: 1rem;
        }
    `}
`;

export const CloseIcon = styled(Cross)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 0.75rem;
    height: 0.75rem;

    @media ${({ theme }) => theme.breakpoints.medium.media} {
        width: 1.25rem;
        height: 1.25rem;
    }
`;
